import TableRow from "@mui/material/TableRow";
import { Box, Chip, styled, useTheme } from "@mui/material";
import { Delete } from "@mui/icons-material";
import { ClickableText, Paragraph } from "../components/Typography";
import PayPal from "../images/paypal.png";
import Venmo from "../images/venmo.png";
import { dateFormat, formatMoney } from "../../../common/utils";

import { LiTableCell } from "../components/pieces";
import type { Payout, AppContext } from "../../../types";

const images: Record<string, string> = {
    paypal: PayPal,
    venmo: Venmo,
};

const brandNames: Record<string, string> = {
    paypal: `PayPal`,
    venmo: `Venmo`,
};

const chipMap: Record<string, "success" | "error" | "info"> = {
    Sent: `success`,
    Completed: `success`,
    Mailed: `success`,
    Returned: `error`,
    Canceled: `error`,
    Requested: `info`,
};

interface PayoutTableRowMobileProps {
    payout: Payout;
    context: AppContext;
    onClick: (payout: Payout) => void;
    openGCard: (payout: Payout) => void;
}

const PayoutTableRowMobile = (props: PayoutTableRowMobileProps) => {
    const { payout, context, onClick, openGCard } = props;
    const MobilePara = styled(Paragraph)(() => ({
        fontSize: `15px`,
    }));
    const theme = useTheme();

    return (
        <TableRow
            selected={false}
            sx={{
                "-webkit-tap-highlight-color": `transparent`,
                border: `none`,
                borderTop: `1px solid #E1E1E1`,
                cursor: `pointer`,
            }}
        >
            <LiTableCell sx={{ padding: `16px`, display: `flex` }}>
                <Box
                    mr="15px"
                    sx={{
                        alignSelf: `center`,
                        maxHeight: `30px`,
                        height: `auto`,
                        maxWidth: 30,
                        width: `auto`,
                    }}
                    component="img"
                    src={images[payout[`Payout Type`]] || payout.icon || payout.logo}
                />
                <Box>
                    <MobilePara sx={{ margin: 0, fontSize: 12 }}>
                        {dateFormat(payout[`Payout Date`] || payout.awardSelectedTs || context.nextFifteen)}
                    </MobilePara>
                    <MobilePara
                        fontWeight={600}
                        sx={{
                            margin: 0,
                            paddingTop: `6px`,
                        }}
                    >
                        {brandNames[payout[`Payout Type`]] || payout[`Payout Type`] || `${payout.brandName} Gift Card`}
                    </MobilePara>
                </Box>
            </LiTableCell>
            <LiTableCell sx={{ padding: `16px`, textAlign: `right`, minWidth: 100 }}>
                <Box sx={{ display: `inline-block`, verticalAlign: `middle` }}>
                    <MobilePara sx={{ margin: 0 }}>
                        <Box
                            sx={{
                                display: `flex`,
                                alignItems: `center`,
                                justifyContent: `center`,
                            }}
                        >
                            {payout.delivery === `mail` ? (
                                <Chip
                                    sx={{ padding: `1px 4px 0`, height: 20 }}
                                    size="small"
                                    label={payout[`Payout Status`] || "Mailed"}
                                    color={chipMap[payout[`Payout Status`]]}
                                />
                            ) : payout[`Payout Status`] === `Completed` ? (
                                <ClickableText
                                    sx={{ fontSize: 12, marginRight: `-5px` }}
                                    onClick={() => openGCard(payout)}
                                >
                                    View My Card
                                </ClickableText>
                            ) : (
                                <Chip
                                    sx={{ padding: `1px 4px 0`, height: 20 }}
                                    size="small"
                                    label={payout[`Payout Status`]}
                                    color={chipMap[payout[`Payout Status`]]}
                                />
                            )}
                        </Box>
                    </MobilePara>
                    <MobilePara sx={{ margin: 0, paddingTop: `3px`, fontWeight: 600 }}>
                        {formatMoney((payout[`Payout Amount`] || payout.awardAmount) as number)}
                    </MobilePara>
                </Box>
                {context?.adminConfig!.mall!.CORE_SETTINGS![`Payout Method`] === `Request` && (
                    <Box sx={{ display: `inline-block`, verticalAlign: `middle` }}>
                        {payout[`Payout Status`] === `Requested` && payout.cancelId && (
                            <Delete
                                sx={{ marginLeft: `10px`, color: theme.palette.error.main }}
                                onClick={() => onClick(payout)}
                            />
                        )}
                    </Box>
                )}
            </LiTableCell>
        </TableRow>
    );
};

export default PayoutTableRowMobile;
